import {
  HeaderComponent,
  PageHeaderComponent,
  MainNavComponent,
  ScrollableNavComponent,
  LoanLayoutComponent,
  StatusBadgePipe
} from './components/index';

import {
  VisibleByPermissionDirective,
  VisibleOnScrollDirective
} from './directives';

export const COMPONENTS = [
  HeaderComponent,
  PageHeaderComponent,
  MainNavComponent,
  ScrollableNavComponent,
  LoanLayoutComponent,
  StatusBadgePipe,
  // Directives
  VisibleByPermissionDirective,
  VisibleOnScrollDirective
];


